// @ts-ignore
import UniversalDateNative from "../sap/ui/core/date/UniversalDate.js";
const UniversalDate = UniversalDateNative;
export default UniversalDate;
//# sourceMappingURL=UniversalDate.js.map